import { useSelector } from "react-redux";
import { selectDatesAndDeadlines } from "../../services/submissionPeriod/slices";
import Deadline from "./Deadline";

function Deadlines() {
  const deadlines = useSelector(selectDatesAndDeadlines);

  const hasDeadlines = !!deadlines?.length;
  if (!hasDeadlines) {
    return false;
  }
  return (
    <dl>
      {deadlines.map(({ description, label }, index) => {
        return (
          <Deadline
            descriptionListItem
            key={"deadline-" + index}
            description={description}
            label={label}
            sx={
              !!index && {
                marginTop: 1,
              }
            }
          />
        );
      })}
    </dl>
  );
}

export default Deadlines;
